import React, { createContext, useContext } from 'react';
import { DEFAULT_WEBSITE_LANGUAGE } from '../../../constants';

type Language = typeof DEFAULT_WEBSITE_LANGUAGE;

export const LanguageContext = createContext<Language>(DEFAULT_WEBSITE_LANGUAGE);

interface LanguageProps {
  value: Language;
  children: React.ReactNode;
}

export const Language = ({ value, children }: LanguageProps) => (
  <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
);

export const useLanguage = () => useContext(LanguageContext);
